<div style="margin-top:5%">
  <h4 class="text-center">THIRD PARTY PAYER CLAIM FORM</h4>
</div>

<br />
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="row" style="margin-top:3%">
    <div class="col-md-12" style="text-align: justify; text-justify: distribute-all-lines">
      <b>ATTENTION: THIS FORM IS ONLY TO BE FILLED OUT ON BEHALF OF A THIRD-PARTY PAYER (OR AN AUTHORIZED AGENT). THIS FORM IS NOT FOR CONSUMERS.</b><br /><br />

      If you are a Consumer, please fill out the Consumer Claim Form, available <a href="/consumer-instructions">here</a>.<br /><br />

      <b>Important</b>: Some users may experience difficulty accessing or submitting the online Claim Form from a mobile device due to
      network or security restrictions. If you encounter issues, please try using a desktop or laptop computer, a different browser, a
      private Wi-Fi connection, or disabling any VPN/proxy service. If problems persist, please contact the Claims Administrator for
      assistance. A paper Claim Form is also available for download along with instructions on how to file a claim by mail are located
      on the <a [routerLink]="['/tpp-instructions']">File a Claim Information</a> page of this website.<br /><br />
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <form [formGroup]="tppForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate #formRef="ngForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="optSectionRadio" formControlName="optSectionRadio" id="1" [ngClass]="{ 'is-invalid': submitted && f.optSectionRadio.errors }" (change)="getRadioOptSectionRadioValue($event)" value="Company">
                <label class="form-check-label" for="1">
                  Complete <b>Section A</b> only if you are filing as an individual TPP Settlement Class Member.
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="optSectionRadio" formControlName="optSectionRadio" id="2" [ngClass]="{ 'is-invalid': submitted && f.optSectionRadio.errors }" (change)="getRadioOptSectionRadioValue($event)" value="Agent">
                <label class="form-check-label" for="2">
                  Complete <b>Section B</b> only if you are an authorized agent filing on behalf of one or more TPP Settlement Class 	Members.
                </label>
                <div *ngIf="submitted && f.optSectionRadio.errors" class="invalid-feedback">
                  <div *ngIf="f.optSectionRadio.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="showDivOptSectionA == true">
          <div class="row lightgraybackground">
            <div class="col-md-12 text-center">
              Section A: Insurer or Self-Insured Settlement Class Member Only
            </div>
          </div>
          <div class="row rowformat mt-4">
            <div class="col-md-12">
              <div class="form-group">
                <label for="insurerOrSelfInsuredName"><b>Insurer or Self-Insured Settlement Class Member Name:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="insurerOrSelfInsuredName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.insurerOrSelfInsuredName.errors }" />
                <div *ngIf="submitted && f.insurerOrSelfInsuredName.errors" class="invalid-feedback">
                  <div *ngIf="f.insurerOrSelfInsuredName.errors.required">This field is required</div>
                  <div *ngIf="f.insurerOrSelfInsuredName.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.insurerOrSelfInsuredName.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.insurerOrSelfInsuredName.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="contactName"><b>Contact Name:</b></label>
                <input type="text" class="form-control" formControlName="contactName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.contactName.errors }" />
                <div *ngIf="submitted && f.contactName.errors" class="invalid-feedback">
                  <div *ngIf="f.contactName.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.contactName.errors.minlength">This field must be at least 2 characters</div>

                  <div *ngIf="f.contactName.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="street1"><b>Address 1:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
                <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
                  <div *ngIf="f.street1.errors.required">This field is required</div>
                  <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.street1.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.street1.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="street2"><b>Address 2:</b></label>
                <input type="text" class="form-control" formControlName="street2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street2.errors }" />
                <div *ngIf="submitted && f.street2.errors" class="invalid-feedback">
                  <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.street2.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.street2.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-4">
              <div class="form-group">
                <label for="city"><b>City:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
                <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                  <div *ngIf="f.city.errors.required">This field is required</div>
                  <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.city.errors.maxlength">This field must not be greater than 40 characters</div>
                  <div *ngIf="f.city.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="state"><b>State:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                  <option value="">Please Select A State</option>
                  <option *ngFor="let allstate of allStates">
                    {{allstate.Name}}
                  </option>
                </select>
                <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                  <div *ngIf="f.state.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="zip"><b>Zip Code:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
                <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
                  <div *ngIf="f.zip.errors.required">This field is required</div>
                  <div *ngIf="f.zip.errors.pattern">
                    US zip Code with format 99999 or 99999-9999 alone are accepted
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="labelBoldWeight" style="font-weight:bold" for="primaryPhone">Primary Phone Number:<span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="primaryPhone" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                       [ngClass]="{ 'is-invalid': f.primaryPhone.errors }" />
                <div *ngIf="f.primaryPhone.errors" class="invalid-feedback">
                  <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                  <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                  <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be greater than 10 digits</div>
                  <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="labelBoldWeight" style="font-weight:bold" for="primaryPhoneType">Primary Phone Type:<span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': f.primaryPhoneType.errors }">
                  <option value="">Please Select Phone Type</option>
                  <option value="Cell">Mobile</option>
                  <option value="Land">Landline</option>
                </select>
                <div *ngIf="f.primaryPhoneType.errors" class="custom-error">
                  <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="tin"><b>Tax Identification Number:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" mask="000000000" class="form-control" formControlName="tin" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.tin.errors }" />
                <div *ngIf="submitted && f.tin.errors" class="invalid-feedback">
                  <div *ngIf="f.tin.errors.required">This field is required</div>
                  <div *ngIf="f.tin.errors.minlength">This field must be at least 9 digits</div>
                  <div *ngIf="f.tin.errors.maxlength">This field must not be greater than 9 digits</div>
                  <div *ngIf="f.tin.errors.pattern">Only use numbers</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="emailAddress"><b>Email Address:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }" />
                <div *ngIf="submitted && f.emailAddress.errors" class="invalid-feedback">
                  <div *ngIf="f.emailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
                  <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                  <div *ngIf="f.emailAddress.errors.required">This field is required</div>

                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="otherNames">
                  <b>List other names by which your company or health plan has been known or other Federal Employer Identification Numbers (“FEINs”) it has used since June 14, 2008.</b>
                </label>
                <input type="text" class="form-control" formControlName="otherNames" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.otherNames.errors }" />
                <div *ngIf="submitted && f.otherNames.errors" class="invalid-feedback">
                  <div *ngIf="f.otherNames.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.otherNames.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.otherNames.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, commas, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-6">
              <div class="form-group">
                <label for="companyHealthType"><b>Health Types:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="companyHealthType" (change)="getCompanyHealthTypesValue($event)" [ngClass]="{ 'is-invalid': submitted && f.companyHealthType.errors }">
                  <option value="">Please select a health type</option>
                  <option *ngFor="let allcompanyhealthtypes of allCompanyHealthTypes">
                    {{allcompanyhealthtypes.Name}}
                  </option>
                </select>
                <div *ngIf="submitted && f.companyHealthType.errors" class="invalid-feedback">
                  <div *ngIf="f.companyHealthType.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="showDivOtherHealthType">
              <div class="form-group">
                <label for="otherCompanyHealthType"><b>Other Health Type:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="otherCompanyHealthType" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.otherCompanyHealthType.errors }" />
                <div *ngIf="submitted && f.otherCompanyHealthType.errors" class="invalid-feedback">
                  <div *ngIf="f.otherCompanyHealthType.errors.required">This field is required</div>
                  <div *ngIf="f.otherCompanyHealthType.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.otherCompanyHealthType.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.otherCompanyHealthType.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="showDivOptSectionB == true">
          <div class="row" style="background-color:lightgray; font-size:1.4em; font-weight:bold">
            <div class="col-md-12 text-center">
              Section B: Authorized Agent Only
            </div>
          </div>
          <br />
          As an authorized agent, please check how your relationship with the Settlement Class Member(s) is best described (you may be required to provide documentation demonstrating this relationship): <br />         <div class="row rowformat mt-4">
            <div class="col-md-6">
              <div class="form-group">
                <label for="relationshipType"><b>Relationship Types:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="relationshipType" (change)="getRelationshipTypesValue($event)" [ngClass]="{ 'is-invalid': submitted && f.relationshipType.errors }">
                  <option value="">Please select a relationship type</option>
                  <option *ngFor="let allrelationshiptypes of allRelationshipTypes">
                    {{allrelationshiptypes.Name}}
                  </option>
                </select>
                <div *ngIf="submitted && f.relationshipType.errors" class="invalid-feedback">
                  <div *ngIf="f.relationshipType.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="showDivOtherRelationshipType">
              <div class="form-group">
                <label for="otherRelationshipType"><b>Other Relationship Type:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="otherRelationshipType" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.otherRelationshipType.errors }" />
                <div *ngIf="submitted && f.otherRelationshipType.errors" class="invalid-feedback">
                  <div *ngIf="f.otherRelationshipType.errors.required">This field is required</div>
                  <div *ngIf="f.otherRelationshipType.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.otherRelationshipType.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.otherRelationshipType.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="agentsCompanyName"><b>Authorized Agent’s Company Name:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="agentsCompanyName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.agentsCompanyName.errors }" />
                <div *ngIf="submitted && f.agentsCompanyName.errors" class="invalid-feedback">
                  <div *ngIf="f.agentsCompanyName.errors.required">This field is required</div>
                  <div *ngIf="f.agentsCompanyName.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.agentsCompanyName.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.agentsCompanyName.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="contactName"><b>Contact Name:</b></label>
                <input type="text" class="form-control" formControlName="contactName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.contactName.errors }" />
                <div *ngIf="submitted && f.contactName.errors" class="invalid-feedback">
                  <div *ngIf="f.contactName.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.contactName.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.contactName.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="street1"><b>Address 1:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
                <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
                  <div *ngIf="f.street1.errors.required">This field is required</div>
                  <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.street1.errors.maxlength">This field must not be greater than 50 characters</div>
                  <div *ngIf="f.street1.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="street2"><b>Address 2:</b></label>
                <input type="text" class="form-control" formControlName="street2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street2.errors }" />
                <div *ngIf="submitted && f.street2.errors" class="invalid-feedback">
                  <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.street2.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.street2.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-4">
              <div class="form-group">
                <label for="city"><b>City:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
                <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                  <div *ngIf="f.city.errors.required">This field is required</div>
                  <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.city.errors.maxlength">This field must not be greater than 40 characters</div>
                  <div *ngIf="f.city.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="state"><b>State:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                  <option value="">Please Select A State</option>
                  <option *ngFor="let allstate of allStates">
                    {{allstate.Name}}
                  </option>
                </select>
                <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                  <div *ngIf="f.state.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="zip"><b>Zip Code:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
                <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
                  <div *ngIf="f.zip.errors.required">This field is required</div>
                  <div *ngIf="f.zip.errors.pattern">
                    US zip Code with format 99999 or 99999-9999 alone are accepted
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="labelBoldWeight" style="font-weight:bold" for="primaryPhone">Primary Phone Number:<span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="primaryPhone" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                       [ngClass]="{ 'is-invalid': f.primaryPhone.errors }" />
                <div *ngIf="f.primaryPhone.errors" class="invalid-feedback">
                  <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                  <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                  <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be greater than 10 digits</div>
                  <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="labelBoldWeight" style="font-weight:bold" for="primaryPhoneType">Primary Phone Type:<span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': f.primaryPhoneType.errors }">
                  <option value="">Please Select Phone Type</option>
                  <option value="Cell">Mobile</option>
                  <option value="Land">Landline</option>
                </select>
                <div *ngIf="f.primaryPhoneType.errors" class="custom-error">
                  <div *ngIf="f.primaryPhoneType.errors.required">This field is required </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="agentsTin"><b>Authorized Agent’s Tax Identification Number:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" mask="000000000" class="form-control" formControlName="agentsTin" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.agentsTin.errors }" />
                <div *ngIf="submitted && f.agentsTin.errors" class="invalid-feedback">
                  <div *ngIf="f.agentsTin.errors.required">This field is required</div>
                  <div *ngIf="f.agentsTin.errors.minlength">This field must be at least 9 digits</div>
                  <div *ngIf="f.agentsTin.errors.maxlength">This field must not be at greater 9 digits</div>
                  <div *ngIf="f.agentsTin.errors.pattern">Only use numbers</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="emailAddress"><b>Email Address:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }" />
                <div *ngIf="submitted && f.emailAddress.errors" class="invalid-feedback">
                  <div *ngIf="f.emailAddress.errors.maxlength">This field must not be at greater 255 characters</div>
                  <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                  <div *ngIf="f.emailAddress.errors.required">This field is required</div>

                </div>
              </div>
            </div>
          </div>

          <div class="row rowformat">
            <div class="col-md-12">
              Please list the name and FEIN of every Settlement Class Member on whose behalf you are submitting a claim. Attach additional sheets to this claim form, as necessary.
              Alternatively, you may submit the requested list of Settlement Class Member names and FEINs in an electronic format, such as Excel or a tab-delimited text file.
              Please contact the Notice Administrator to determine what formats are acceptable.
            </div>
          </div>

          <br /><br />

          <div class="card card-body bg-light">
            <div class="row mb-3">
              <div class="col-md-6">
                <button type="button" (click)="addData()" class="btn btn-primary btn-sm">Add A Class Member</button>
              </div>
            </div>
            <div formArrayName="classMembers" *ngFor="let classMember of classMembers().controls; let i = index">
              <div [formGroupName]="i">
                <div style="border: 1px solid black; padding-left: 1%; padding-right: 1%; padding-top: 1%; padding-bottom: 1%">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="classMemberName">SETTLEMENT CLASS MEMBER’S NAME:</label>
                        <input type="text" class="form-control" formControlName="classMemberName" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{'is-invalid': classMemberARR(i).controls['classMemberName'].errors && (classMemberARR(i).controls['classMemberName'].dirty ||
                         classMemberARR(i).controls['classMemberName'].touched || classMemberARR(i).controls['classMemberName'].pristine)}" />
                        <div *ngFor="let validation of validation_ClassMembersErrorMessage.classMemberName" class="invalid-feedback">
                          <div *ngIf="classMemberARR(i).controls['classMemberName'].hasError(validation.type) && (classMemberARR(i).controls['classMemberName'].dirty ||
                        classMemberARR(i).controls['classMemberName'].touched || classMemberARR(i).controls['classMemberName'].pristine)">
                            {{ validation.message }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="classMemberFEIN">SETTLEMENT CLASS MEMBER’S FEIN:</label>
                        <input type="text" mask="000000000" class="form-control" formControlName="classMemberFEIN" placeholder="" autocomplete="no" trim="blur"
                               [ngClass]="{'is-invalid': classMemberARR(i).controls['classMemberFEIN'].errors && (classMemberARR(i).controls['classMemberFEIN'].dirty ||
                          classMemberARR(i).controls['classMemberFEIN'].touched || classMemberARR(i).controls['classMemberFEIN'].pristine)}" />
                        <div *ngFor="let validation of validation_ClassMembersErrorMessage.classMemberFEIN" class="invalid-feedback">
                          <div *ngIf="classMemberARR(i).controls['classMemberFEIN'].hasError(validation.type) && (classMemberARR(i).controls['classMemberFEIN'].dirty ||
                        classMemberARR(i).controls['classMemberFEIN'].touched || classMemberARR(i).controls['classMemberFEIN'].pristine)">
                            {{ validation.message }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <button type="button" class="btn btn-danger" (click)="removeData(i)">Remove</button>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
            <br />
          </div>
        </div>
        <br />
        <div class="row lightgraybackground">
          <div class="col-md-12 text-center">
            Section C: Purchase Information
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            Please type or print, in the box below, the total dollar amount you paid and/or reimbursed (net of co-pays, deductibles, and co-insurance)
            for Named Generic Drugs that were purchased, not for resale, in any of the 50 United States (except Indiana and Ohio), the District of
            Columbia, Puerto Rico, or the U.S. Virgin Islands, from May 1, 2009, through December 31, 2019. Do not include any payments for drugs
            purchased directly from Defendants or purchased for purposes of resale.<br /><br />

            Please note that certain groups have been excluded from the EPP Settlement Classes in this case. See the “ELIGIBLITY REQUIREMENTS”
            section of the instructions above. Do not submit a claim for or on behalf of an entity in an excluded group or an entity that has
            been opted out of all of the Settlement Classes.<br /><br />

            If you have purchases that meet the definition of a Settlement Class or Classes, but you also have purchases that fall within one
            or more of the exclusions set forth in the “ELIGIBILITY REQUIREMENTS” section above, include only those purchases that satisfy the
            eligibility requirements (e.g., do not include direct purchases, purchases for resale, purchases in Indiana and Ohio, etc. in the
            dollar amount below).<br /><br />

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="totalAmountPaid">
                    <b>TOTAL AMOUNT <u>YOU</u> PAID FOR ELIGIBLE PURCHASES OF NAMED GENERIC DRUGS – NET OF CO-PAYS, DEDUCTIBLES, AND CO-INSURANCE</b>
                    <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                  </label>
                  <input type="text" class="form-control" id="totalAmountPaid" formControlName="totalAmountPaid" autocomplete="no"
                         trim="blur" [ngClass]="{ 'is-invalid': submitted && f.totalAmountPaid.errors }" />
                  <div *ngIf="submitted && f.totalAmountPaid.errors" class="invalid-feedback">
                    <div *ngIf="f.totalAmountPaid.errors.required">This field is required</div>
                    <div *ngIf="f.totalAmountPaid.errors.pattern">
                      Only use numbers with optional period (.), Minimum of 1 and a Maximum of 9 digits before the decimal period, and up to 2 digits passed the decimal are allowed
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <b>Authorized Agents Only</b>: Fill out the box above with the combined eligible amounts paid by all Settlement Class Members for whom you are
            submitting this claim form, net of co-pays, deductibles, and co-insurance. If you are submitting claims for multiple Settlement Class Members,
            please provide, separately for each Settlement Class Member, the transaction data and other information and documentation requested in the
            “CLAIM INFORMATION AND DOCUMENTATION REQUIREMENTS” section of the instructions above.<br /><br />
          </div>
        </div>
        <div class="row lightgraybackground">
          <div class="col-md-12 text-center">
            Section D: Proof of Payment and Disputes Regarding Claim Amounts
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            Please provide the information requested in the CLAIM INFORMATION AND DOCUMENTATION REQUIREMENTS section of the instructions above.
            Please keep all related transaction data and any other documents supporting your claim in case the Notice Administrator requests it
            later. If, after your claim is audited, the Notice Administrator determines that you have not provided sufficient documentation to
            substantiate your claim, the Notice Administrator may reject your claim.<br /><br />

            If the Notice Administrator rejects or reduces your claim, and you believe the rejection or reduction is in error, you may contact
            the Notice Administrator within 14 days of the rejection or reduction to request further review. You must submit any additional
            documentation and arguments at that time. If the dispute concerning your claim cannot be resolved by the Notice Administrator and
            Class Counsel, you may request that the Court review your claim.<br /><br />

            To request Court review, you must send the Notice Administrator a signed written statement (via U.S. Mail at the mailing address
            below, or via email at the email address below) that (a) states the reasons you contest the rejection or payment determination
            regarding your claim, and (b) specifically states that you “request that the Court review the determination regarding this claim.”
            You must include all documentation supporting your argument(s). Your request must be postmarked or emailed no later than 21 days
            after the Notice<br /><br />

            Administrator’s response to your request for Notice Administrator review. The Notice Administrator and Class Counsel will present
            the dispute to the Court for review, which may include publicly filing your claim and any supporting documentation with the Court.
            The Court may refer your dispute to a Special Master; if it does, <u>you will be required to pay 50% of the Special Master’s fee</u>.
            <br /><br />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12">
            <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
            <label for="file" class="btn btn-primary btn-sm">Documents To Upload</label>
            <br />
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <table class="table" #listofFiles>
              <thead>
                <tr>
                  <th>Files To Be Uploaded</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let sd of supportingDocuments; let i = index">
                  <td class="hidden">{{i}}</td>
                  <td>{{sd.name}}</td>
                  <td>
                    <button type="button" class="btn btn-danger"
                            (click)="removeRow(i)">
                      Remove
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <br /><br />
        <div class="row lightgraybackground">
          <div class="col-md-12 text-center">
            Section E: Settlement Class Membership
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            Please review the “<b>ELIGIBILITY REQUIREMENTS</b>” section of the instructions, above, for a description of the entities that are included
            and excluded from the Settlements. Check the box next to the Settlement Class(es) that you belong to:<span style="color:red; font-weight:bold" class="required"> *At Least one Checkbox is Required</span><br /><br />


            <div class="row">
              <div class="col-md-6">
                <div class="form-group form-check">
                  <input type="checkbox" formControlName="sandoxSettlementClass" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.sandoxSettlementClass.errors }" ngModel />
                  <label for="sandoxSettlementClass">
                    <b>Sandoz Settlement Class</b>
                  </label>
                  <div *ngIf="f.sandoxSettlementClass.errors" class="invalid-feedback">
                    <!--<div *ngIf="f.sandoxSettlementClass.errors.required">This field is required</div>-->
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group form-check">
                  <input type="checkbox" formControlName="apotexSettlementClass" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.apotexSettlementClass.errors }" ngModel />
                  <label for="apotexSettlementClass">
                    <b> Apotex Settlement Class</b>
                  </label>
                  <div *ngIf="f.apotexSettlementClass.errors" class="invalid-feedback">
                    <!--<div *ngIf="f.apotexSettlementClass.errors.required">This field is required</div>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group form-check">
                  <input type="checkbox" formControlName="heritageSettlementClass" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.heritageSettlementClass.errors }" ngModel />
                  <label for="heritageSettlementClass">
                    <b>Heritage Settlement Class</b>
                  </label>
                  <div *ngIf="f.heritageSettlementClass.errors" class="invalid-feedback">
                    <!--<div *ngIf="f.heritageSettlementClass.errors.required">This field is required</div>-->
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group form-check">
                  <input type="checkbox" formControlName="sunTaroSettlementClass" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.sunTaroSettlementClass.errors }" ngModel />
                  <label for="sunTaroSettlementClass">
                    <b>Sun/Taro Settlement Class</b>
                  </label>
                  <div *ngIf="f.sunTaroSettlementClass.errors" class="invalid-feedback">
                    <!--<div *ngIf="f.sunTaroSettlementClass.errors.required">This field is required</div>-->
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <br /><br />
        <div class="row lightgraybackground">
          <div class="col-md-12 text-center">
            Section F: Certification
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">

            I have read and am familiar with the contents of the instructions accompanying this claim form. I certify that the information in the
            above claim form and any documents attached are true, correct, and complete to the best of my knowledge. I certify that I, or the
            Settlement Class Member(s) I represent, indirectly purchased, paid, and/or provided reimbursement for some or all of the purchase
            price for one or more of the Named Generic Drugs, other than for resale, in one or more of the 50 United States (except Indiana and
            Ohio), the District of Columbia, Puerto Rico, or the U.S. Virgin Islands, between May 1, 2009, and December 31, 2019.<br /> <br />

            I also certify that where I have asserted that I am a member of one or more of the EPP Settlement Classes, I did not ask to be
            excluded (or “opted out”) from those EPP Settlement Classes. I further certify that if I am filing a claim on behalf of another
            entity and have asserted that it is a member of one or more of the EPP Settlement Classes, that entity did not ask to be excluded
            from those EPP Settlement Classes.<br /> <br />

            In addition, I certify that any Settlement Class Member(s) whose claims I am submitting are not: (a) Defendants and their officers,
            directors, management, employees, subsidiaries, and affiliates; (b) federal governmental entities; (c) state governmental entities
            (except for cities, towns, municipalities, counties, and other local governmental entities with self-funded prescription drug plans);
            (d) persons or entities who only purchased Named Generic Drugs for purposes of resale or directly from Defendants; (e) fully insured
            employers to the extent that they use fully-insured plans (i.e., employers that purchased insurance covering 100% of their
            reimbursement obligation to members); (f) pharmacy benefit managers; or (g) governmental Medicaid agencies or private Medicaid
            managed care organizations.<br /> <br />

            I also certify that I have provided all the information requested above.<br /> <br />

            I further certify that I have not submitted data for direct purchases, or purchases for resale, of Named Generic Drugs.<br /> <br />

            To the extent I have been given authority to submit this claim form by one or more Settlement Class Members on their behalf, and
            accordingly am submitting this claim form in the capacity of an authorized agent of the Settlement Class Member(s) identified on
            this form, and to the extent I have been authorized to receive on behalf of those Settlement Class Member(s) any and all amounts
            that may be allocated to them from the Settlement Funds, I certify that such authority has been properly vested in me and I will
            fulfill all duties I owe the Settlement Class Member(s), including forwarding the Settlement Class Member(s) their share(s) of the
            Settlement Funds. In the event amounts from the Settlement Funds are distributed to me, and a Settlement Class Member later claims
            that I did not have the authority to claim and/or receive such amounts on its behalf, I and my employer will hold the EPP Sandoz
            Settlement Class; the EPP Apotex Settlement Class; the EPP Heritage Settlement Class; the EPP Sun/Taro Settlement Class; counsel
            for the EPP Settlement Classes; Sandoz; Apotex; Heritage; Sun/Taro; and the Notice Administrator harmless with respect to any
            claims made by the Settlement Class Member.<br /> <br />

            I hereby submit to the jurisdiction of the United States District Court for the Eastern District of Pennsylvania for all
            purposes connected with this claim, including resolution of disputes. I acknowledge that any false information or representations
            in this claim form or any documents provided by me may subject me to sanctions, including the possibility of criminal prosecution.
            I agree to supplement this claim form and provide documentary backup for the information provided herein, upon request of the
            Notice Administrator.<br /> <br />

            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="form-group form-check">
                  <input type="checkbox" formControlName="signatureConfirmation" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.signatureConfirmation.errors }" ngModel required />
                  <label for="signatureConfirmation">
                    <b><u>I certify that the above information supplied by the undersigned is true and correct to the best of my knowledge.</u></b>
                    <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                  </label>
                  <div *ngIf="f.signatureConfirmation.errors" class="invalid-feedback">
                    <div *ngIf="f.signatureConfirmation.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br /> <br />
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="signature"><b>Electronic Signature:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                     trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
              <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
                <div *ngIf="f.signature.errors.required">This field is required</div>
                <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
                <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
                <div *ngIf="f.signature.errors.pattern">
                  Only use letters, numbers, periods, spaces, hyphens,
                  brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="agentSignature"><b>Position/Title:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" class="form-control" formControlName="positionTitle" autocomplete="no"
                     trim="blur" [ngClass]="{ 'is-invalid': submitted && f.positionTitle.errors }" />
              <div *ngIf="submitted && f.positionTitle.errors" class="invalid-feedback">
                <div *ngIf="f.positionTitle.errors.maxlength">This field must not be at greater 50 characters</div>
                <div *ngIf="f.positionTitle.errors.minlength">This field must be at least 2 characters</div>
                <div *ngIf="f.positionTitle.errors.required">This field is required</div>

                <div *ngIf="f.positionTitle.errors.pattern">
                  Only use letters, numbers, periods, spaces, hyphens,
                  brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" ngDefaultControl [ngClass]="{ 'is-invalid': submitted && f.googleRecaptchaToken.errors }"></re-captcha>
              <div *ngIf="submitted && f.googleRecaptchaToken.errors">
                <div *ngIf="f.googleRecaptchaToken.errors.required" class="custom-error">This field is required</div>
              </div>
            </div>
          </div>
        </div>
        <ul class="list-inline text-center">
          <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
        </ul>
        <div class="row">
          <div class="col-md-12 text-center">
            <div *ngIf="showDivSubmittalErrorMessage == true" class="submittal-custom-error" style="color:red">
              Missing information or information was not entered in correctly, please review "Section A" OR "Section B", "Section C: Purchase Information",
              "Section E: Settlement Class Membership", and "Section F: Certification"
              ensure all fields have been filled out correctly before attempting to submit again.
            </div>
          </div>
        </div>
      </form>
      <br />
    </div>
      <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                   size="medium"
                   color="#fff"
                   type="ball-scale-multiple">
        <p style="font-size: 20px; color: white">Loading...</p>
      </ngx-spinner>
      <br />
      <br />
    </div>
  </div>
